module.exports = __webpack_public_path__ + "img/23.ffe18530.png";